import { render, staticRenderFns } from "./accounttype.vue?vue&type=template&id=878c63c4&scoped=true&"
import script from "./accounttype.vue?vue&type=script&lang=js&"
export * from "./accounttype.vue?vue&type=script&lang=js&"
import style0 from "./accounttype.vue?vue&type=style&index=0&id=878c63c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878c63c4",
  null
  
)

export default component.exports